//import Message from "../../models/Message";
import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async createChatMessage(context, chatMessage) {
      if (chatMessage.isDirty === true) {
        const store = this;
        let data = {
          accountId: chatMessage.accountId,
          chatId: chatMessage.chatId,
          isInbound: false,
          userId: chatMessage.userId,
          message: chatMessage.message
        };
        try {
          let response = await axios({
            method: "post",
            url: API_BASE_URL + `/chat-message`,
            data: data,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/chatMessages/delete", {
            where: chatMessage.tempId
          });
          store.dispatch("entities/chatMessages/insert", {
            where: response.id,
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    }
  }
};
